import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "loading-element fixed top-0 left-0 z-50 h-screen w-screen flex items-center justify-center transition-all duration-1000 ease-in-out" }
const _hoisted_2 = { class: "relative z-30 p-10" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "mr-2 w-1/2" }
const _hoisted_6 = { class: "ml-2 w-1/2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonSecondary = _resolveComponent("ButtonSecondary")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute top-0 left-0 z-20 h-full w-full bg-black opacity-80" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        ref: "modal",
        class: "bg-white p-6 focus:outline-none",
        tabindex: "0",
        onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["esc"]))
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("global.defaults.deleteConfirmation", { item: _ctx.text })), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ButtonSecondary, {
              type: "button",
              name: _ctx.$t('global.defaults.no'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
            }, null, 8, ["name"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Button, {
              type: "button",
              name: 
                _ctx.$t('global.defaults.yes') + ', ' + _ctx.$t('global.defaults.delete')
              ,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteMe()))
            }, null, 8, ["name"])
          ])
        ])
      ], 32)), [
        [_directive_click_away, _ctx.closeModal]
      ])
    ])
  ]))
}